const KEY = 'marbs_scoring_session';

export interface ScoringSession {
  roundId: string;
  groupId: string;
  groupName: string;
  joinCode?: string; // stored so we can rejoin with a new anonymous UID after admin sign-out
}

export function saveScoringSession(session: ScoringSession): void {
  try {
    localStorage.setItem(KEY, JSON.stringify(session));
  } catch {
    // ignore storage errors
  }
}

export function getScoringSession(): ScoringSession | null {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    return JSON.parse(raw) as ScoringSession;
  } catch {
    return null;
  }
}

export function clearScoringSession(): void {
  try {
    localStorage.removeItem(KEY);
  } catch {
    // ignore
  }
}
